// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import type { Position } from '@/types/profileTypes';

export const usePositionsBySport = (sportId: string | null) => {
  const [positions, setPositions] = useState<Position[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPositions = async () => {
      if (!sportId) {
        setPositions([]);
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const { data, error } = await supabase
          .from('positions')
          .select('*')
          .eq('sport_id', sportId)
          .order('position_name', { ascending: true });

        if (error) {
          throw error;
        }

        setPositions(data || []);
        setError(null);
      } catch (err: any) {
        console.error('Error fetching positions:', err);
        setError(err.message || 'Failed to fetch positions');
        setPositions([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPositions();
  }, [sportId]);

  return { positions, isLoading, error };
};
